import { usePersistQueryClient, PersistOptions } from '@/hooks/usePersistQueryClient';

interface QueryPersistProviderProps {
  children: React.ReactNode;
  options?: PersistOptions;
}

export function QueryPersistProvider({ children, options }: QueryPersistProviderProps) {
  // Configurar persistencia
  usePersistQueryClient(options);
  
  // El provider solo retorna los children, la persistencia se maneja en el hook
  return <>{children}</>;
} 